var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("skoly-menu", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c(
        "main",
        {
          staticClass:
            "profileDashboard skolska-sekcia-main justify-content-center"
        },
        [
          _c("article", [
            _c(
              "aside",
              {
                staticClass:
                  "rounded-10 main-banner banner-skoly position-relative"
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: "assets/img/skolsky-banner-main.png", alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "position-absolute d-flex flex-column align-items-start"
                  },
                  [
                    _c("h2", { staticClass: "mb-20" }, [
                      _vm._v("Veľa šťastia pri riešení úloh v školskej súťaži")
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass: "btn --primary",
                        attrs: {
                          to: {
                            name: "skoly-ulohy",
                            params: {
                              rocnik: _vm.profil.pouzivatel_id.pouzivatel_rocnik
                            }
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                        Riešiť úlohy\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(0)
                  ],
                  1
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("aside", [
            _c("div", { staticClass: "m-skolskaKarta mb-30" }, [
              _c("h5", { staticClass: "a-skolskaKarta__title" }, [
                _vm._v("počet bodov")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _c(
                    "div",
                    { staticClass: "a-skolskaKarta__value text-success" },
                    [_vm._v(_vm._s(_vm.profil.pouzivatel_id.pouzivatel_body))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "a-skolskaKarta__button" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn --primary --circle",
                          attrs: { to: { name: "skoly-body" } }
                        },
                        [_c("span", { staticClass: "icon --arrow-right" })]
                      )
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-skolskaKarta mb-30" }, [
              _c("h5", { staticClass: "a-skolskaKarta__title" }, [
                _vm._v("vyplnené úlohy")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _c(
                    "div",
                    { staticClass: "a-skolskaKarta__value text-danger" },
                    [_vm._v(_vm._s(_vm.uspesnost))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "a-skolskaKarta__button" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn --primary --circle",
                          attrs: {
                            to: {
                              name: "skoly-ulohy",
                              params: {
                                rocnik:
                                  _vm.profil.pouzivatel_id.pouzivatel_rocnik
                              }
                            }
                          }
                        },
                        [_c("span", { staticClass: "icon --arrow-right" })]
                      )
                    ],
                    1
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-skolskaKarta" }, [
              _c("h5", { staticClass: "a-skolskaKarta__title" }, [
                _vm._v("žiakov v našej triede")
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between"
                },
                [
                  _c("div", { staticClass: "a-skolskaKarta__value" }, [
                    _vm._v(
                      _vm._s(_vm.profil.pouzivatel_id.pouzivatel_pocet_ziakov)
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "a-skolskaKarta__button" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn --primary --circle",
                          attrs: { to: { name: "skoly-trieda" } }
                        },
                        [_c("span", { staticClass: "icon --arrow-right" })]
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex mt-auto" }, [
      _c("span", { staticClass: "icon icon--info text-icon mr-10 pt-5" }),
      _vm._v(" "),
      _c("p", { staticClass: "mb-0 line-24" }, [
        _vm._v("Pozrite sa každý mesiac, čo je tu nové")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }